import MenuCard from './MenuCard.vue';

export default MenuCard;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/remotemenu/components/menucard/index.ts